import type { Quote } from "@/components/marketplace/bnpl/testimonials"
import { Stack, Stars, Text } from "@/components/ui"

export const MiniQuote = ({ name, loc, text, stars = 5 }: Omit<Quote, "stars"> & { stars?: number }) => (
  <div className="@container">
    <Stack
      gap="200"
      className="rounded-12x border-line-subtle bg-surface-newgray border p-500 shadow-sm @3xl:mx-auto @3xl:max-w-200 @3xl:flex-row @3xl:items-center @3xl:gap-500 @3xl:px-700 @3xl:py-600"
    >
      <Stars value={stars} size={13} className="text-star-fill shrink-0" />
      <Text as="p" variant="body" family="text" tone="default" className="@3xl:text-body-lg flex-1">
        &ldquo;{text}&rdquo;
      </Text>
      <Text as="div" variant="bodySm" family="display" tone="subtle" className="shrink-0">
        <b className="text-fg font-bold">{name}</b> · {loc}
      </Text>
    </Stack>
  </div>
)
